<h1 mat-dialog-title i18n>Create Platform</h1>

<form [formGroup]="formInputs" (ngSubmit)="onCreate()">
	<div mat-dialog-content class="main-content px-3">
		<mat-form-field appearance="standard" class="w-100">
			<mat-label i18n>Platform Name</mat-label>
			<input matInput formControlName="platform" placeholder="e.g. android-tv" i18n-placeholder />
			<mat-error *ngIf="formInputs.get('platform').hasError('required')" i18n>Platform name is required</mat-error>
		</mat-form-field>
	</div>

	<div mat-dialog-actions class="row px-1 mb-0 justify-content-center">
		<div class="col-6 text-center">
			<button class="w-100" type="submit" [disabled]="!formInputs.valid" mat-flat-button color="primary" i18n>Create</button>
		</div>
		<div class="col-6 text-center">
			<button class="w-100" type="button" (click)="close()" mat-stroked-button i18n>Cancel</button>
		</div>
	</div>
</form>

